import { render, staticRenderFns } from "./myIncome.vue?vue&type=template&id=64ef7c28&scoped=true"
import script from "./myIncome.vue?vue&type=script&lang=js"
export * from "./myIncome.vue?vue&type=script&lang=js"
import style0 from "./myIncome.vue?vue&type=style&index=0&id=64ef7c28&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef7c28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ef7c28')) {
      api.createRecord('64ef7c28', component.options)
    } else {
      api.reload('64ef7c28', component.options)
    }
    module.hot.accept("./myIncome.vue?vue&type=template&id=64ef7c28&scoped=true", function () {
      api.rerender('64ef7c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/myIncome.vue"
export default component.exports